import styled from 'styled-components';

import { zindex } from 'utils/style/zindex';

import { black, gray, exactWhite, boxShadow1 } from 'utils/style/colors';

export const sidebarBackgroundColor = exactWhite;

type WrapperProps = {
  collapsed: boolean;
};

export const SidebarWrapper = styled('div')<WrapperProps>`
  background-color: ${(props) => !props.collaped && sidebarBackgroundColor};

  display: flex;
  flex-direction: column;
  position: relative;
  transition: all 0.2s ease-in-out;
  z-index: ${zindex.navigation};
  color: ${black};
  margin: 2rem 0;
  border-radius: 1.5rem;
  box-shadow: ${(props) =>
    !props.collapsed &&
    (props.theme.direction === 'rtl'
      ? `${boxShadow1}`
      : `-2px 2px 1rem ${gray}`)};
  ${(props) =>
    props.collapsed
      ? `
          flex: 0 0 0;
          max-width: 30px;
          min-width: 30px;
          width: 30px;
        `
      : `
          max-width: 235px;
          min-width: 235px;
          width: 235px;
          margin-inline-start: 1rem;
          margin-inline-end: 0.5rem;
        `};

  @media only screen and (max-width: 800px) {
    ${(props) =>
      props.collapsed
        ? `
      flex: 0 0 0;
      max-width: 30px;
      min-width: 30px;
      width: 30px;
      border: 0
      margin: 0.5rem;
      `
        : `
    max-width: 235px;
    min-width: 235px;
    width: 235px;
    margin: 0.5rem;
    margin-inline-start: 1rem;
    margin-inline-end: 0.5rem;
  `};
  }

  @media only screen and (max-width: 600px) {
    position: absolute;
    margin-inline-start: 0.5rem !important;
    height: 100%;
    width: ${(props) => (props.collapsed ? '0' : '235px')};
    min-width: ${(props) => (props.collapsed ? '0' : '235px')};
    flex: ${(props) => (props.collapsed ? '0' : '0 0 30px')};
    z-index: 202020;
    background: ${(props) =>
      props.collapsed ? 'transparent' : `${exactWhite}`};
    max-height: calc(100% - 1rem);
  }
`;

export const SidebarContent = styled('div')`
  height: 100%;
  overflow-y: auto;
  padding-bottom: 3.5rem;
`;

export const TriggerArea = styled('div')`
  align-items: center;
  // recently added
  background: ${exactWhite};
  color: ${black};
  //
  cursor: pointer;
  flex: none;
  display: inline-flex;
  height: 3rem;
  justify-content: center;
  line-height: 3rem;
  text-align: center;
  width: 100%;
  border-radius: 15px;
  z-index: ${zindex.navigation + 1};
`;
export const EmptyArea = styled('div')`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 3rem;
  margin: auto;
  color: ${black};
  align-items: center;
  font-size: 10px;
  border-inline-start: 3px solid ${gray};
  margin: 0 5px;
  overflow: hidden;
  background: rgb(234, 234, 234);
  gap: 1rem;
  //border-radius: 10px;
`;

// new style for profile dropdown
export const ProfileDropDownHeader = styled.div`
  margin: ${(props) => (props.isCollapsed ? '0.5rem 0' : '1rem 0.5rem')};
`;

export const ProfileDropDownUserName = styled.span`
  flex-grow: 1;
  padding: 0 1rem;
  display: flex;
  flex-direction: column;
  color: ${black};

  @media only screen and (max-width: 700px) {
    ${(props) => props.enableMobileViewMode && 'display: none'};
  }
`;

export const RolesContainer = styled.div`
  width: 100%;
  background-color: transparent;
  color: ${black};
  display: flex;
  flex-direction: column;
  padding: 0.25rem 0.75rem;
  align-items: flex-start;
  border-bottom: 1px solid ${gray};
`;

export const RolesHeader = styled.div`
  padding-top: 0.5rem;
  font-weight: bold;
`;

export const BoxRoles = styled.div`
  border-inline-start: 4px solid ${(props) => props.color};
  padding-inline-start: 0.25rem;
  margin-bottom: 0.5rem;
  color: ${(props) => props.color};
`;

export const BurgerMenu = styled.div<{ isOpen: boolean }>`
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  width: 2rem;
  height: 2rem;
  background: transparent;
  border: none;
  cursor: pointer;
  padding: 0;
  z-index: ${zindex.navigation + 1};
  margin: 1rem;
  order: -1;
  position: absolute;
  transform: ${(props) =>
    props.isOpen
      ? `translateY(0rem) ${props.theme.direction === 'rtl' ? 'translateX(0.5rem)' : 'translateX(-0.5rem)'}`
      : '0'};
  transition: all 0.5s ease-in-out;

  div {
    width: 2rem;
    height: 0.15rem;
    background: ${black};
    border-radius: 10px;
    transition: all 0.3s linear;
    position: relative;
    transform-origin: 1px;

    &:first-child {
      transform: ${({ isOpen }) => (isOpen ? 'rotate(45deg)' : 'rotate(0)')};
    }

    &:nth-child(2) {
      opacity: ${({ isOpen }) => (isOpen ? '0' : '1')};
      transform: ${({ isOpen }) =>
        isOpen ? 'translateX(20px)' : 'translateX(0)'};
    }

    &:nth-child(3) {
      transform: ${({ isOpen }) => (isOpen ? 'rotate(-45deg)' : 'rotate(0)')};
    }
  }
`;

export const ThemeModeContainer = styled.div`
  color: ${black};
  padding: 0.25rem 0.75rem;
  width: 100%;
`;
